// src/components/common/StatCard.js

import React from 'react';

const StatCard = ({ title, value, icon, color }) => {
  return (
    <div className={`${color} text-white rounded-lg shadow-md p-6 flex flex-col items-start justify-between min-h-[140px]`}>
      <div className="text-4xl mb-3">{icon}</div> {/* Icon display */}
      <h3 className="text-lg font-semibold mb-1">{title}</h3>
      <p className="text-3xl font-bold">{value}</p>
    </div>
  );
};

export default StatCard;
